// extracted by mini-css-extract-plugin
export var icon = "_6p-1";
export var subtext = "_6p-0";